import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { default as request } from "@pb/utils/request";
import { getLocale } from "@pb/utils/locale";
import constants from '../../constants';
import { errorHandler, mapRecommendationsToCarousel } from '../../helpers';
import { CarouselNS as Carousel } from '../Carousel';
const RelatedArticlesContainer = ({ className, praConfiguration, articleid, textpriorprice, relatedarticlelabel, breakpoint, }) => {
    const [showCarousel, setShowCarousel] = useState(false);
    const [originSource, setOriginSource] = useState('');
    const [finalProducts, setProducts] = useState([]);
    const [trackedRelatedArticles, setTrackedRelatedArticles] = useState(undefined);
    const relatedArticleInitialLabel = relatedarticlelabel && JSON.parse(relatedarticlelabel);
    const [relatedArticleLabel] = useState(relatedArticleInitialLabel || undefined);
    const removeRelatedArticlesComponents = () => {
        var _a;
        // at a given point, there can be more than 1 pra2 on the page if the article has matching
        // articles. Hence, remove such instances of pra2 when an article has no matching articles
        document.querySelectorAll('#prod-reco-pra2').forEach((pra2Element) => pra2Element.remove());
        (_a = document.querySelector('.relatedArticlesCTA')) === null || _a === void 0 ? void 0 : _a.remove();
    };
    const afterFetch = ({ articles, origin }) => {
        if (articles === null || articles === void 0 ? void 0 : articles.length) {
            const finalSet = mapRecommendationsToCarousel(Object.assign({ articles,
                praConfiguration, disableFavorites: false }, (textpriorprice && { priorPriceLabel: textpriorprice })));
            if (finalSet.length > 0) {
                setOriginSource(origin || '');
                setProducts(finalSet);
                setShowCarousel(true);
            }
        }
    };
    const fetchRecommendations = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const locale = getLocale(null, 'en_gb', null, { useAEMLocaleInfo: true });
            const domain = process.env.API_DOMAIN_RELATED_ARTICLES;
            const apiKey = process.env.API_KEY_RELATED_ARTICLES;
            const timeout = constants.API.TIMEOUT;
            if (!articleid) {
                removeRelatedArticlesComponents();
                setShowCarousel(false);
                throw new Error('No valid article provided.');
            }
            const path = `/recos/relatedarticles/v1/${locale === null || locale === void 0 ? void 0 : locale.toLowerCase()}/articles/${articleid}?apiKey=${apiKey}`;
            const constructedURL = `${domain}${path}`;
            const { data } = yield request.get(constructedURL, { timeout });
            afterFetch(data);
        }
        catch (error) {
            removeRelatedArticlesComponents();
            setShowCarousel(false);
            errorHandler(error);
        }
    });
    useEffect(() => {
        fetchRecommendations();
    }, [articleid]);
    if (!showCarousel) {
        return null;
    }
    return (React.createElement(Carousel, { className: className, finalProducts: finalProducts, praConfiguration: praConfiguration, origin: originSource, carouselTitle: relatedArticleLabel === null || relatedArticleLabel === void 0 ? void 0 : relatedArticleLabel.praTitle, showDotsWithArrows: process.env.IS_PRA_DOTS_WITH_ARROWS === 'enabled', articleId: articleid, trackedArticles: trackedRelatedArticles, setTrackedArticles: (articles) => {
            setTrackedRelatedArticles(articles);
        }, breakpoint: breakpoint }));
};
export default RelatedArticlesContainer;
//# sourceMappingURL=RelatedArticlesContainerNS.js.map